<template>
  <div class="ti-page-start py2">
    <div class="lg-section px3">
      <h2 v-if="!loading" class="detail-header-title">
        Vendor Connect Admin<template v-if="vendor">: {{vendor.name}}</template>
      </h2>
      <p>
        <router-link :to="{name: 'admin-home', params: {id: vendorId}}" class="ti-link">
          BACK
        </router-link>
      </p>
    </div>

    <template v-if="!loading">
      <div v-if="canAccess" class="lg-section px2 pt3">
        <template v-if="kind=='baseline'">
          <h3 class="ti-h3 mb1">Baseline</h3>
          <p class="mb1">
            This information will be displayed in all Vendor Connect cells that you have
            purchased, unless more detailed information is provided.
          </p>
        </template>
        <template v-if="kind=='tech'">
          <h3 class="ti-h3 mb1">Technology Capabilities: {{def.label}}</h3>
          <p class="mb1">
            Do you have any generic Technology capabilities
            that you want to highlight across all Verticals?
          </p>
        </template>
        <template v-if="kind=='vert'">
          <h3 class="ti-h3 mb1">Vertical Capabilities: {{def.label}}</h3>
          <p class="mb1">
            If you would like to add specific details about your abilities
            in vertical sectors, please select the sector below.
          </p>
        </template>
        <template v-if="kind=='sp'">
          <h3 class="ti-h3 mb1">Specific Capabilities: {{def.label}}</h3>
          <p class="mb1">
            Do you have any capabilities in specific Vertical and Technology
            pairs that you want to highlight?
          </p>
        </template>

        <div v-if="!editMode">
          <div v-if="capData">
            <div v-for="item in def.items" :key="item.id" style="margin-top:4px;">
              <span class="ti-prop-label" :title="item.desc">{{item.label}}: </span>
              <span class="ti-prop-value">{{capData[item.id]}}</span>
            </div>
          </div>
          <p v-else class="py2 bold">
            <template v-if="kind=='sp'">
              Specific values not set. Displayed content will be drawn from
              Baseline, Technology and Sector inputs.
            </template>
            <template v-else>
              Values not set.
            </template>
          </p>
          <div class="my2">
            <a class="btn btn-neutral" @click="editCapability()">Edit</a>
            <router-link :to="{name: 'admin-home', params: {id: vendorId}}"
                         class="btn btn-neutral ml3">
              done
            </router-link>
            <a v-if="capData" class="ml3 btn btn-danger" @click="removeCapability()">Remove</a>
          </div>

          <template v-if="kind=='sp'">
              <h4 class="ti-h4 mt3">Preview</h4>
              <CapabilityCard :vendorId="vendorId"
                              :vendorName="vendor.name"
                              :preview="true"
                              :showHeaders="false"
                              :contacts="preview.contacts"
                              :tech="preview.tech" :vertical="preview.vertical"
                              :attrs="preview.props" class="mt2"/>
          </template>
        </div> <!-- view Mode -->

        <div v-else>
          <p class="ti-note" style="text-align:right;">* Limit of 500 characters per field</p>
          <p v-if="def.hasBaseTech">
            <button @click="getTechValues()">fill with tech values</button>
          </p>
          <div class="my2 ti-form">
            <div v-for="item in def.items" :key="item.id" class="mb1">
              <div class="form-label">
                <label>{{item.label}}</label>
                <span style="margin-left:10px; font-size:10px;color:#666;">{{item.desc}}</span>
              </div>
              <div>
                <textarea v-model="formData[item.id]" class="form-input" :rows="3" maxlength="500"/>
              </div>
            </div>
            <div v-if="errorMsg" class="my2" style="color:red;">
              {{errorMsg}}
            </div>
            <button class="btn btn-neutral" @click="cancel()">Cancel</button>
            <button class="btn btn-primary ml2" @click="saveCapability()">Save</button>
          </div>
        </div>
      </div> <!-- canAccess -->
    </template> <!-- if loaded -->
  </div>
</template>

<script>
import axios from 'axios';

import util from './util';
import CapabilityCard from './CapabilityCard.vue';


export default {
  name: 'AdminCap',
  components: { CapabilityCard },
  props: ['kind'],
  data() {
    return {
      loading: true,
      canAccess: null,
      vendorId: this.$route.params.id,
      code: this.$route.params.code,
      vendor: null,
      def: null,
      capData: null,
      preview: null,
      isDraft: null,
      hasPublished: null,

      editMode: false,
      formData: null,
      errorMsg: null,
    };
  },

  created() {
    const params = { [this.kind]: this.code };
    if (this.kind === 'baseline') {
      // baseline does not use code, but if value is undefined.
      // The param is not included in the request.
      params.baseline = '0';
    }
    axios.get(`/api/connect-admin/${this.vendorId}`, { params })
      .then((res) => {
        this.canAccess = res.data.canAccess;
        this.vendor = res.data.vendor;
        this.def = res.data.def;
        this.capData = res.data.capData;
        this.isDraft = res.data.isDraft;
        this.hasPublished = res.data.hasPublished;
        this.preview = res.data.preview;
        this.loading = false;
      });
  },

  methods: {
    editCapability() {
      this.formData = Object.assign({}, this.capData);
      this.editMode = true;
    },
    cancel() {
      this.formData = null;
      this.editMode = false;
    },
    saveCapability() {
      this.errorMsg = '';
      const error = util.validateEmailAddresses(this.formData.contacts);
      if (error) {
        this.errorMsg = error;
        return;
      }
      const params = { form: this.kind, code: this.code };
      axios.post(`/api/connect-admin/${this.vendorId}`, this.formData, { params })
        .then((res) => {
          if (res.data.result === 'ok') {
            this.capData = this.formData;
            this.editMode = false;
            this.formData = null;
          } else {
            let errorMsg = 'Error';
            if (res.data.msg) {
              errorMsg = res.data.msg;
            }
            this.errorMsg = errorMsg;
          }
        });
    },
    removeCapability() {
      const params = { form: this.kind, code: this.code };
      axios.post(`/api/connect-admin/${this.vendorId}`, { __op__: 'remove' }, { params })
        .then((res) => {
          if (res.data.result === 'ok') {
            this.capData = null;
            this.editMode = false;
            this.formData = null;
          } else {
            let errorMsg = 'Error';
            if (res.data.msg) {
              errorMsg = res.data.msg;
            }
            alert(errorMsg);
          }
        });
    },

    getTechValues() {
      const params = { tech: this.code.split('-')[0] };
      axios.get(`/api/connect-admin/${this.vendorId}`, { params })
        .then((res) => {
          const data = Object.assign(this.formData, res.data.capData);
          this.formData = data;
          this.$forceUpdate();
        });
    },
  },
};
</script>

<style scoped>
</style>
